import './App.css'
import Login from './pages/Login';
import ResetPwd from './pages/ResetPwd';
import Home from './pages/Home';
import RegistFirstStep from './pages/RegistFirstStep';
import Manage from './pages/Manage';
import ManageLogin from './pages/ManageLogin';
import ForgetPwd from './pages/ForgetPwd';
import Display from './pages/Display';
import AboutUs from './pages/AboutUs';
import Search from './pages/Search';
import SearchInput from './pages/Search/SearchInput';
import { Col, ConfigProvider, Dropdown, Row, Menu, Drawer, Button, Typography, Grid, Space } from 'antd';
import { Route, Navigate, Routes, useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react';
import {
  DownOutlined,
  RetweetOutlined,
  LoginOutlined,
  AuditOutlined,
  MenuOutlined,
  GlobalOutlined,
  SafetyCertificateOutlined,
  UserOutlined
} from '@ant-design/icons'
import ScrollToTop from './pages/ScrollTop/ScrollToTop.jsx';
import ResearchTeam from './pages/ResearchTeam/index.jsx';
import DataAccess from './pages/DataAccess/index.jsx';
import Ethics from './pages/Ethics/index.jsx';
import Publications from './pages/Publications/index.jsx';
import Acknowledgement from './pages/Acknowledgement/index.jsx';
import Profile from './pages/Profile/index.jsx';
import GsrdWch from './components/GsrdWch.jsx';
import RGNET from './pages/RGNET';

const { Text } = Typography;
const { useBreakpoint } = Grid;

function App() {
  const userInfo = localStorage.getItem("userInfo");
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const [currentKey, setCurrentKey] = useState('display');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Sync menu key with path on initial load or manual navigation
    const path = location.pathname.split('/')[1];
    if (path) {
      setCurrentKey(path);
    } else {
      setCurrentKey('display');
    }
  }, [location.pathname]);

  const menuItems = [
    { label: 'HOME', key: 'display' },
    { label: 'IMPUTATION', key: 'home' },
    { label: 'VARIANT SEARCH', key: 'searchInput' },
    { label: 'RGNET', key: 'rgnet' },
    { label: 'PUBLICATIONS', key: 'publications' },
    {
      label: 'ABOUT US',
      key: 'aboutUs_parent',
      children: [
        { label: 'RESEARCH TEAM', key: 'researchTeam' },
        { label: 'DATA ACCESS & LICENSING', key: 'dataAccess' },
        { label: 'ETHICS & COMPLIANCE', key: 'ethics' },
        { label: 'ACKNOWLEDGEMENT', key: 'acknowledgement' },
        { label: 'ABOUT PROJECT', key: 'aboutUs' },
      ]
    },
  ];

  const userMenuItems = [
    {
      key: '0',
      label: <a onClick={() => navigate('/profile')}>{"Profile"}</a>,
      icon: <UserOutlined />,
    },
    {
      key: '1',
      label: <a onClick={() => navigate('/resetPwd')}>{"Change password"}</a>,
      icon: <RetweetOutlined />,
    },
    {
      key: '2',
      label: <a onClick={() => { navigate('/display'); localStorage.clear(); window.location.reload(); }}>{"Log out"}</a>,
      icon: <LoginOutlined />,
    },
    ...(localStorage.getItem("manage") === "1" ? [{
      key: '3',
      label: <a onClick={() => navigate('/manage')}>{"User Audit"}</a>,
      icon: <AuditOutlined />,
    }] : []),
  ];

  const onMenuClick = (e) => {
    if (!userInfo && ['home', 'searchInput'].includes(e.key)) {
      // 未登录访问受限页面时记录原始目标页，登录成功后回到对应功能页
      navigate('/login', { state: { from: '/' + e.key } });
      setMobileMenuOpen(false);
      return;
    }
    setCurrentKey(e.key);
    navigate('/' + e.key);
    setMobileMenuOpen(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowX: 'hidden' }}>
      <ScrollToTop />

      {/* Navigation Header */}
      <header className="app-site-header">
        <Row style={{ width: '100%', padding: '0 36px' }} align="middle" justify="space-between">
          {/* Logo Area */}
          <Col>
            <a
              className="app-brand-mark"
              onClick={() => navigate('/display')}
            >
              {/* 顶部菜单使用首页同款 PNG logo，统一站点品牌识别 */}
              <img
                src="https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/gsrd-logo-new2.png"
                alt="GSRD-100K WCH"
              />
            </a>
          </Col>

          {/* Desktop Menu */}
          {screens.md ? (
            <Col flex="auto" style={{ marginLeft: '58px' }}>
              <ConfigProvider theme={{
                components: {
                  Menu: {
                    horizontalItemSelectedColor: '#fff',
                    itemColor: 'rgba(255,255,255,0.86)',
                    itemHoverColor: '#fff',
                    popupBg: '#0c5369',
                    itemSelectedColor: '#fff',
                    itemFontSize: 14,
                    activeBarHeight: 2,
                    activeBarBorderRadius: 2
                  }
                }
              }}>
                <Menu
                  className="app-main-menu"
                  mode="horizontal"
                  onClick={onMenuClick}
                  selectedKeys={[currentKey]}
                  items={menuItems}
                  style={{
                    backgroundColor: 'transparent',
                    borderBottom: 'none',
                    lineHeight: '72px'
                  }}
                />
              </ConfigProvider>
            </Col>
          ) : null}

          {/* User / Login Area */}
          <Col>
            <Space size="large">
              {userInfo ? (
                <Dropdown overlayClassName="app-user-dropdown" menu={{ items: userMenuItems }} placement="bottomRight">
                  <a className="app-user-trigger" onClick={e => e.preventDefault()}>
                    <Space>
                      {!screens.xs && localStorage.getItem('email')}
                      <DownOutlined className="app-user-arrow" />
                    </Space>
                  </a>
                </Dropdown>
              ) : (
                <Button
                  ghost
                  icon={<LoginOutlined />}
                  onClick={() => navigate('/login', { state: { from: '/display' } })}
                  style={{ borderRadius: '6px', border: '1px solid rgba(255,255,255,0.4)' }}
                >
                  {"Login"}
                </Button>
              )}

              {/* Mobile Hamburger Toggle */}
              {!screens.md && (
                <Button
                  type="text"
                  icon={<MenuOutlined style={{ color: 'white', fontSize: '20px' }} />}
                  aria-label={"Open navigation"}
                  onClick={() => setMobileMenuOpen(true)}
                />
              )}
            </Space>
          </Col>
        </Row>
      </header>

      {/* Mobile Navigation Drawer */}
      <Drawer
        title={<span style={{ color: '#055878', fontWeight: 800 }}>{"NAVIGATION"}</span>}
        placement="right"
        onClose={() => setMobileMenuOpen(false)}
        open={mobileMenuOpen}
        closable
        width={280}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          onClick={onMenuClick}
          selectedKeys={[currentKey]}
          items={menuItems}
          style={{ borderRight: 'none' }}
        />
      </Drawer>

      {/* Main Content Area */}
      <main style={{
        flex: 1,
        paddingTop: '72px',
        background: '#fff'
      }}>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path='/login' element={<Login />} />
          <Route path='/resetPwd' element={<ResetPwd />} />
          <Route path='/registFirstStep' element={<RegistFirstStep />} />
          <Route path='/manage' element={<Manage />} />
          <Route path='/manageLogin' element={<ManageLogin />} />
          <Route path='/forgetPwd' element={<ForgetPwd />} />
          <Route path='/display' element={<Display setKey={setCurrentKey} />} />
          <Route path='/aboutUs' element={<AboutUs />} />
          <Route path='/search' element={<Search />} />
          <Route path='/searchInput' element={<SearchInput />} />
          <Route path="/rgnet" element={<RGNET />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/researchTeam" element={<ResearchTeam />} />
          <Route path="/dataAccess" element={<DataAccess />} />
          <Route path="/ethics" element={<Ethics />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/acknowledgement" element={<Acknowledgement />} />
          <Route path="/*" element={<Navigate to="/display" />} />
        </Routes>
      </main>

      {/* Modern Footer */}
      <footer style={{
        background: '#f0f4f7',
        padding: '40px 24px',
        borderTop: '1px solid #e1e8ed',
        zIndex: 2
      }}>
        <Row justify="center" align="middle" gutter={[0, 16]}>
          <Col xs={24} style={{ textAlign: 'center' }}>
            <Space direction="vertical" size={12}>
              <div style={{ color: '#666', fontSize: '14px', fontWeight: '500' }}>
                <GlobalOutlined style={{ marginRight: '8px' }} />
                {<>Web Development @2024 <GsrdWch /> Team</>}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
                <a
                  href='https://beian.miit.gov.cn/'
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: '#055878', fontSize: '13px' }}
                >
                  蜀ICP备2023012330号-2
                </a>
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=51015602000840"
                  rel="noreferrer"
                  target="_blank"
                  style={{ color: '#055878', fontSize: '13px', display: 'flex', alignItems: 'center' }}
                >
                  <img
                    src={'https://gsrd-server.tos-cn-beijing.volces.com/beian.png'}
                    height='14px'
                    style={{ marginRight: '6px' }}
                    alt={"security-icon"}
                  />
                  川公网安备51015602000840
                </a>
                <Text type="secondary" style={{ fontSize: '13px' }}>
                  <SafetyCertificateOutlined style={{ marginRight: '4px' }} /> {"Security Certified"}
                </Text>
              </div>
            </Space>
          </Col>
        </Row>
      </footer>
    </div>
  );
}

export default App;
